export default __webpack_public_path__ + "static/media/photo-line-5.5bce5207.png";